import React, { useEffect } from 'react';
import {
  Byline,
  ExhibitionContainer,
  Paragraph,
  SectionTitle,
  PageTitle,
  HeroImage,
  HeroCaption,
  FeatureImage
} from '../../styles/exhibitionStyles';

export default function NewsICVA() {
  useEffect(() => {
    document.title = "Institute of Contemporary Visionary Art Partnership - SLEEPR";
  }, []);

  return (
    <ExhibitionContainer>
      <HeroImage src="/img/artworks-1920/sleepr_1920_120.jpg" alt="Institute of Contemporary Visionary Art" />
      <HeroCaption>Above: The Other Side (2025), Sleepr.</HeroCaption>

      <PageTitle>Partnership with the Institute of Contemporary Visionary Art</PageTitle>
      <Byline>
        In April 2025, Sleepr joined the Institute of Contemporary Visionary Art, marking a significant step in the development and academic recognition of visionary art in contemporary culture.
      </Byline>

      <FeatureImage src="/img/icva/icva-long-black.png" alt="ICVA Logo" />

      <SectionTitle>Advancing Visionary Art in Contemporary Culture</SectionTitle>
      <Paragraph>
        The Institute of Contemporary Visionary Art (ICVA) represents a groundbreaking initiative in the art world, dedicated to bridging the gap between visionary experiences and contemporary artistic expression. Through this partnership, Sleepr will work closely with the institution to develop and articulate the philosophical frameworks that underpin his unique artistic approach. This collaboration marks a significant step in legitimizing and advancing the academic discourse around visionary art in contemporary culture.
      </Paragraph>

      <Paragraph>
        At the heart of this partnership lies a shared commitment to exploring the intersection of consciousness, artistic expression, and philosophical inquiry. Sleepr's work, known for its documentation of hyperspace realms and exploration of altered states of consciousness, aligns perfectly with ICVA's mission to develop the academic and philosophical maturity of visionary artists. The institution will provide a platform for deeper theoretical exploration of Sleepr's methodologies and findings, contributing to a broader understanding of visionary art's role in contemporary society.
      </Paragraph>

      <Paragraph>
        Through this collaboration, ICVA will support Sleepr in building relationships with other prestigious institutions and museums worldwide. This network will facilitate the placement of his works in significant collections and exhibitions, ensuring that visionary art reaches broader audiences and gains recognition within the contemporary art establishment. The partnership represents a crucial step in legitimizing visionary art within traditional art institutions while maintaining its unique perspective and methodologies.
      </Paragraph>

      <Paragraph>
        Looking ahead, this partnership will involve various initiatives, including academic research, publications, and collaborative projects that explore the boundaries between traditional art practices and visionary experiences. Sleepr's role will extend beyond that of an artist, contributing to the development of theoretical frameworks that help contextualize visionary art within contemporary art discourse. This work will help establish a foundation for future generations of artists working at the intersection of consciousness exploration and artistic expression.
      </Paragraph>
    </ExhibitionContainer>
  );
}
